import { Component, OnInit, Input, Output, EventEmitter, HostBinding } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { MStepper, CustomValidatorsService } from '@argalis-apps/angular-global';
import { MUser, MResa } from '@argalis-apps/models';
import { CartConfigService } from '../../services/cart-config/cart-config.service';
import { AuthService } from '../../../auth/services/auth/auth.service';

@Component({
  selector: 'ags-participant',
  templateUrl: './participant.component.html',
  styleUrls: ['./participant.component.scss']
})
export class ParticipantComponent implements OnInit, MStepper.IStepComponent {
  @HostBinding('class') themeFlag: string;
  @Input() public step: MStepper.IStep;
  @Output() public backStep = new EventEmitter<any>();
  @Output() public validation = new EventEmitter<any>();
  public formParticipant: UntypedFormGroup;
  public optionAppr: MUser.CContact;
  public currentResa: MResa.CResa;

  // paramétrages & options
  public listCiv: string[] = ['M.', 'Mme'];
  public listOptionsAppr: MUser.CContact[] = [];

  constructor(
    private authService: AuthService,
    private cartConfigService: CartConfigService,
    private formBuilder: UntypedFormBuilder,
    private customValidatorsService: CustomValidatorsService
  ) {}

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.cartConfigService.themingClassName}`;
    this.formParticipant = this.formBuilder.group({
      civ: [null],
      nom: [null, Validators.required],
      prenom: [null, Validators.required],
      role: [null],
      birthdate: [null, Validators.required],
      phone: [null],
      mobile: [null],
      mail: [null, [Validators.required, Validators.email]],
      confirmmail: [
        null,
        [Validators.required, Validators.email, this.customValidatorsService.confirmCaseInsensitive('mail')]
      ]
    });
    this.currentResa = this.step.dataInput;
    this.refreshOptions();
  }

  public addApprenant(nextStep: boolean) {
    let newAppr: MUser.CContact;

    if (this.optionAppr.id === -2) {
      newAppr = new MUser.CContact();
      newAppr.id = 0;
      newAppr.name = 'A CONFIRMER';
      newAppr.firstName = 'A CONFIRMER';
      newAppr.mail = 'A CONFIRMER';
    } else if (this.optionAppr.id === -1) {
      newAppr = new MUser.CContact({
        id: 0,
        civ: this.formParticipant.value['civ'],
        name: this.formParticipant.value['nom'],
        firstName: this.formParticipant.value['prenom'],
        birthDate: this.formParticipant.value['birthdate'],
        role: this.formParticipant.value['role'],
        phone: this.formParticipant.value['phone'],
        mobile: this.formParticipant.value['mobile'],
        mail: this.formParticipant.value['mail'],
        addr: null
      });
      this.authService?.userConnected?.company?.apprenants.push(newAppr); // ajout en base ? besoin d'un id_question pour list option
      this.formParticipant.reset();
    } else {
      newAppr = new MUser.CContact(this.optionAppr);
    }

    this.currentResa.participants.push(newAppr); // ajout en base ?
    this.refreshOptions();

    if (nextStep) this.goToNextStep();
  }

  public remove(idx: number) {
    this.currentResa.participants.splice(idx, 1);
    this.refreshOptions();
  }

  public backToPrevStep() {
    this.backStep.emit(false);
  }

  public goToNextStep() {
    this.validation.emit(true);
  }

  private refreshOptions() {
    this.listOptionsAppr = [];
    this.listOptionsAppr.push(new MUser.CContact());
    this.listOptionsAppr[this.listOptionsAppr.length - 1].id = -2;
    this.listOptionsAppr[this.listOptionsAppr.length - 1].name = 'Ajouter un participant non identifié';
    this.listOptionsAppr.push(new MUser.CContact());
    this.listOptionsAppr[this.listOptionsAppr.length - 1].id = -1;
    this.listOptionsAppr[this.listOptionsAppr.length - 1].name = 'Ajouter un nouveau participant';
    this.listOptionsAppr.push(...this.authService.userConnected.company.apprenants);
    this.listOptionsAppr = this.listOptionsAppr.filter(
      opt =>
        !this.currentResa.participants.find(appr =>
          opt.id === 0 ? new MUser.CContact(appr).fullName === opt.fullName : appr.id === opt.id
        )
    );

    if (!this.optionAppr || this.optionAppr.id >= 0) this.optionAppr = this.listOptionsAppr.find(opt => opt.id === -1);
  }
}
